import { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { MapPin, Phone, ArrowLeft, Star, Users, ChefHat } from "lucide-react";
import api, { resolveImg } from "@/lib/api";

export default function PizzeriaDetail() {
  const { id } = useParams();
  const nav = useNavigate();
  const [p, setP] = useState(null);

  useEffect(() => { api.get(`/pizzerias/${id}`).then((r) => setP(r.data)).catch(() => setP(false)); }, [id]);

  if (p === false) return <div className="max-w-3xl mx-auto px-4 py-24 text-center"><h1 className="font-display text-3xl cc-navy">Pizzeria introuvable</h1><Link to="/annuaire" className="text-cc-red font-bold mt-4 inline-block">Retour à l'annuaire</Link></div>;
  if (!p) return <div className="min-h-[50vh] grid place-items-center font-display text-2xl cc-navy">Chargement…</div>;

  return (
    <div>
      <div className="relative h-56 sm:h-72 overflow-hidden">
        <img src={p.image_url} alt={p.name} className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-cc-navy/90 to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pb-6 text-white">
          <Link to="/annuaire" className="text-white/80 font-bold inline-flex items-center gap-1 hover:text-cc-gold"><ArrowLeft size={16} /> Annuaire</Link>
          <h1 className="font-display text-4xl sm:text-5xl mt-2">{p.name}</h1>
          <p className="flex items-center gap-1 text-white/90"><MapPin size={16} /> {p.address}</p>
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-10 grid lg:grid-cols-3 gap-8">
        <div className="lg:col-span-1 space-y-4">
          <div className="card-cocarde p-5">
            <p className="eyebrow text-cc-blue flex items-center gap-2 mb-2"><Users size={15} /> Les gérants</p>
            <p className="text-slate-700 text-sm">{p.managers || "Une équipe passionnée, fière partenaire Cocarde Pizza."}</p>
          </div>
          <div className="card-cocarde p-5">
            <p className="eyebrow text-cc-blue mb-2">La boutique</p>
            <p className="text-slate-700 text-sm">{p.description}</p>
            {p.phone && <p className="text-slate-500 text-sm flex items-center gap-1 mt-2"><Phone size={14} /> {p.phone}</p>}
          </div>
          <Link to="/commander" data-testid="detail-order-btn" className="btn-cocarde w-full text-center block">Commander ici</Link>
        </div>

        <div className="lg:col-span-2">
          <h2 className="font-display text-3xl cc-navy mb-4">La carte</h2>
          <div className="grid sm:grid-cols-2 gap-4">
            {(p.menu || []).map((pz) => (
              <div key={pz.id} data-testid={`detail-pizza-${pz.id}`} className="card-cocarde overflow-hidden">
                <div className="h-32 overflow-hidden relative">
                  <img src={resolveImg(pz.image_url)} alt={pz.name} className="w-full h-full object-cover" />
                  {pz.is_specialty && <span className="absolute top-2 left-2 bg-cc-gold text-cc-navy text-xs font-bold rounded-full px-2 py-0.5 flex items-center gap-1"><Star size={11} /> Spécialité</span>}
                  {pz.custom && <span className="absolute top-2 left-2 bg-green-600 text-white text-xs font-bold rounded-full px-2 py-0.5 flex items-center gap-1"><ChefHat size={11} /> Fait maison</span>}
                </div>
                <div className="p-3 flex justify-between items-center">
                  <div><p className="font-display text-lg cc-navy">{pz.name}</p><p className="text-slate-500 text-xs">{pz.description}</p>{pz.ingredients && <p data-testid={`detail-ingredients-${pz.id}`} className="text-cc-navy/70 text-xs mt-1 italic">{pz.ingredients}</p>}</div>
                  <span className="font-display text-lg text-cc-red shrink-0">{pz.price.toFixed(2)} €</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
